import {ApiClient} from './api'

export class ClutchService {
    apiClient = null

    constructor(token, site, baseUrl) {
        this.apiClient = new ApiClient(baseUrl, token, null, null, site)
    }

    async redeemGiftCard(cardNumber, pinNumber, customerId, basketid) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                cardNumber: cardNumber,
                pinNumber: pinNumber,
                basketId: basketid
            }),
            headers: {
                customerid: customerId,
                basketid: basketid
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }

    async voidGiftCard(orderNo) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                orderNo: orderNo
            })
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }

    async placeHold(requestBody) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                requestBody: requestBody
            })
        })

        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
